import { useState, useEffect } from 'react';

interface ScrollToTopProps {
  onBeforeScroll?: () => void;
}

export default function ScrollToTop({ onBeforeScroll }: ScrollToTopProps = {}) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    onBeforeScroll?.();
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    // Clear hash from URL
    if (window.location.hash) {
      window.history.replaceState(null, '', window.location.pathname);
    }
  };

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 z-40 w-10 h-10 bg-[#8B1538] text-white rounded-full shadow-lg hover:bg-[#6B0F2A] transition-all duration-300 flex items-center justify-center group hover:shadow-xl"
          aria-label="Scroll to top"
        >
          <i className="ri-arrow-up-line text-xl transition-transform group-hover:-translate-y-0.5"></i>
        </button>
      )}
    </>
  );
}
